export const STREET_ADDRESS = 'street_address'
export const NEIGHBORHOOD = 'neighborhood'
export const LOCALITY = 'locality'
export const ADDRESS = 'address'
export const ROUTE = 'route'
export const PREMISE = 'premise'
export const SUBPREMISE = 'subpremise'
export const AIRPORT = 'airport'
export const PARK = 'park'
export const POINT_OF_INTEREST = 'point_of_interest'
export const COUNTRY = 'country'
export const BOX_PARAMETER_ORDER = ['minLng', 'minLat', 'maxLng', 'maxLat']
// https://developers.google.com/maps/documentation/geocoding/intro#Types
export const POI_TYPES = [PREMISE, SUBPREMISE, POINT_OF_INTEREST]
export const STREET_ADDRESS_TYPES = [STREET_ADDRESS, PREMISE, SUBPREMISE, POINT_OF_INTEREST]
export const NEIGHBORHOOD_TYPES = [NEIGHBORHOOD, PARK, AIRPORT]
